
import React from "react";
import "./pagestyles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">

      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>Last Updated: March 2026</p>
      </div>

      <div className="privacy-content">

        <section>
          <h2>1. Introduction</h2>
          <p>
            Your privacy is important to us. This Privacy Policy explains how we
            collect, use, disclose, and protect your information when you use
            our website, products, and services.
          </p>
          <p>
            By accessing our website, you agree to the collection and use of
            information in accordance with this policy.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We may collect several types of information including:</p>

          <ul>
            <li>Personal information such as name, email address, and phone number.</li>
            <li>Account information if you register on our platform.</li>
            <li>Technical data such as IP address, browser type, and device information.</li>
            <li>Usage data including pages visited, time spent, and interactions.</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To provide and maintain our services.</li>
            <li>To improve website performance and user experience.</li>
            <li>To communicate updates, newsletters, and offers.</li>
            <li>To detect fraud or security issues.</li>
            <li>To comply with legal obligations.</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar technologies to improve functionality,
            analyze traffic, and personalize content.
          </p>
          <p>
            Cookies help us remember your preferences and understand how users
            interact with our website.
          </p>
        </section>

        <section>
          <h2>5. Sharing Your Information</h2>
          <p>We may share information with:</p>

          <ul>
            <li>Service providers who assist in operating our website.</li>
            <li>Analytics and marketing partners.</li>
            <li>Authorities when required by law.</li>
          </ul>

          <p>
            We do not sell your personal information to third parties.
          </p>
        </section>

        <section>
          <h2>6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect your personal data from unauthorized access, loss, or
            disclosure.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>You may have the following rights depending on your jurisdiction:</p>

          <ul>
            <li>Access your personal information</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of personal data</li>
            <li>Object to certain data processing activities</li>
          </ul>
        </section>

        <section>
          <h2>8. Third-Party Links</h2>
          <p>
            Our website may contain links to external websites. We are not
            responsible for the privacy practices of third-party websites.
          </p>
        </section>

        <section>
          <h2>9. Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 13.
            We do not knowingly collect personal data from children.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be
            posted on this page with a revised date.
          </p>
        </section>

        <section>
          <h2>11. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, contact us:</p>

          <p>Email: support@yourcompany.com</p>
          <p>Address: Your Company Address</p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;